class Sena {
  constructor(num_factura, monto, metodo) {
    this.num_factura = num_factura;
    this.monto = monto;
    this.metodo = metodo;
  }
}

export default Sena;
